jQuery(document).ready(function() {
    function displayNav(carousel) {
        var nav = carousel.next('.carousel-prev');

        nav.toggleClass('active', carousel.find('.owl-wrapper-outer .owl-item.active:first').is(':first-child') === false);
        nav.next('.carousel-next').toggleClass('active', carousel.find('.owl-wrapper-outer .owl-item.active:last').is(':last-child') === false);
    }
/* -------------------------------------------------------
 * CAROUSEL CONDENSED
 * ------------------------------------------------------*/

    jQuery(".carousel-condensed").each(function () {
        var carousel = jQuery(this).owlCarousel({
            items : 8,
            itemsCustom : [
                [0, 2],
                [768, 3],
                [992, 5],
                [1200, 8],
                [1600, 10],
            ],
            pagination: false,
            scrollPerPage : true,
            slideSpeed: 1500,
            autoPlay: false,
            stopOnHover: true,
            rewindNav: true,
            rewindSpeed: 1000,
            addClassActive: true,
            afterMove: function(event) {
                displayNav(carousel);
            },
        });

        jQuery(this).closest('.carousel-wrapper').children(".carousel-prev").click(function(){
            carousel.trigger('owl.prev');
        });
		var next = jQuery(this).closest('.carousel-wrapper').children(".carousel-next");
		next.click(function(){
			carousel.trigger('owl.next');
		});
		if (window.screen.width >= 1600 && jQuery(this).find("img").length > 10) {
			next.addClass('active');
		} if (window.screen.width >= 1200 && window.screen.width < 1600 && jQuery(this).find("img").length > 8) {
			next.addClass('active');
		} else if (window.screen.width >= 992 && window.screen.width < 1200 && jQuery(this).find("img").length > 5) {
			next.addClass('active');
		} else if (window.screen.width >= 768 && window.screen.width < 992 && jQuery(this).find("img").length > 3) {
			next.addClass('active');
		} else if (window.screen.width < 768 && jQuery(this).find("img").length > 2) {
			next.addClass('active');
		}
    });

    jQuery(".carousel-condensed-svod").each(function () {
        var carousel = jQuery(this).owlCarousel({
            items : 8,
            itemsCustom : [
                [0, 2],
                [768, 3],
                [992, 5],
                [1200, 8],
                [1600, 10],
            ],
            pagination: false,
            scrollPerPage : true,
            slideSpeed: 1500,
            autoPlay: false,
            stopOnHover: true,
            rewindNav: true,
            rewindSpeed: 1000,
            addClassActive: true,
            afterMove: function(event) {
                displayNav(carousel);
            },
        });

        jQuery(this).closest('.carousel-wrapper').children(".carousel-prev").click(function(){
            carousel.trigger('owl.prev');
        });
		var next = jQuery(this).closest('.carousel-wrapper').children(".carousel-next");
		next.click(function(){
			carousel.trigger('owl.next');
		});
		if (window.screen.width >= 1600 && jQuery(this).find("img").length > 10) {
			next.addClass('active');
		} if (window.screen.width >= 1200 && window.screen.width < 1600 && jQuery(this).find("img").length > 8) {
			next.addClass('active');
		} else if (window.screen.width >= 992 && window.screen.width < 1200 && jQuery(this).find("img").length > 5) {
			next.addClass('active');
		} else if (window.screen.width >= 768 && window.screen.width < 992 && jQuery(this).find("img").length > 3) {
			next.addClass('active');
		} else if (window.screen.width < 768 && jQuery(this).find("img").length > 2) {
			next.addClass('active');
		}
    });



/* -------------------------------------------------------
 * CAROUSEL EXPANDED
 * ------------------------------------------------------*/
    jQuery(".carousel-expanded").each(function () {
        var carousel = jQuery(this).owlCarousel({
            items : 5,
            itemsCustom : [
                [0, 3],
                [992, 4],
                [1200, 5],
                [1600, 6],
            ],
            pagination: true,
            scrollPerPage : true,
            slideSpeed: 1500,
            autoPlay: false,
            stopOnHover: true,
            rewindNav: true,
            rewindSpeed: 1000,
            lazyLoad: true,
            addClassActive: true,
            afterMove: function(event) {
                displayNav(carousel);
            },
        });

        jQuery(this).closest('.carousel-wrapper').children(".carousel-prev").click(function(){
            carousel.trigger('owl.prev');
        });
		var next = jQuery(this).closest('.carousel-wrapper').children(".carousel-next");
		next.click(function(){
			carousel.trigger('owl.next');
		});
		if (window.screen.width >= 1600 && jQuery(this).find("img").length > 6) {
			next.addClass('active');
		} else if (window.screen.width >= 1200 && window.screen.width < 1600 && jQuery(this).find("img").length > 5) {
			next.addClass('active');
		} else if (window.screen.width >= 992 && window.screen.width < 1200 && jQuery(this).find("img").length > 4) {
			next.addClass('active');
		} else if (window.screen.width < 992 && jQuery(this).find("img").length > 2) {
			next.addClass('active');
		}
    });

    jQuery(".carousel-expanded-svod").each(function () {
        var isMobile = jQuery(this).data('responsive') === 'mobile';
        var carousel, next;
        if (!isMobile) {
            carousel = jQuery(this).owlCarousel({
                items : 4,
                itemsCustom : [
                    [0, 1],
                    [576, 2],
                    [992, 3],
                    [1200, 4],
                ],
                pagination: true,
                scrollPerPage : true,
                slideSpeed: 1500,
                autoPlay: false,
                stopOnHover: true,
                rewindNav: true,
                rewindSpeed: 1000,
                lazyLoad: true,
                addClassActive: true,
                afterMove: function(event) {
                    displayNav(carousel);
                },
            });


            jQuery(this).closest('.carousel-wrapper').children(".carousel-prev").click(function(){
                carousel.trigger('owl.prev');
            });

            next = jQuery(this).closest('.carousel-wrapper').children(".carousel-next");
            next.click(function(){
                carousel.trigger('owl.next');
            });
            if (window.screen.width >= 1200 && jQuery(this).find("img").length > 4) {
                next.addClass('active');
            } else if (window.screen.width >= 992 && window.screen.width < 1200 && jQuery(this).find("img").length > 3) {
                next.addClass('active');
            } else if (window.screen.width >= 576 && window.screen.width < 992 && jQuery(this).find("img").length > 2) {
                next.addClass('active');
            } else if (window.screen.width < 576 && jQuery(this).find("img").length > 1) {
                next.addClass('active');
            }
        } else {
            carousel = jQuery(this).owlCarousel({
                items : 5,
                itemsCustom : [
                    [0, 1],
                    [992, 4],
                    [1200, 5],
                    [1600, 6],
                ],
                pagination: true,
                scrollPerPage : true,
                slideSpeed: 1500,
                autoPlay: false,
                stopOnHover: true,
                rewindNav: true,
                rewindSpeed: 1000,
                lazyLoad: true,
                addClassActive: true,
                afterMove: function(event) {
                    displayNav(carousel);
                },
            });

            jQuery(this).closest('.carousel-wrapper').children(".carousel-prev").click(function(){
                carousel.trigger('owl.prev');
            });
            next = jQuery(this).closest('.carousel-wrapper').children(".carousel-next");
            next.click(function(){
                carousel.trigger('owl.next');
            });
            if (window.screen.width >= 1600 && jQuery(this).find("img").length > 6) {
                next.addClass('active');
            } else if (window.screen.width >= 1200 && window.screen.width < 1600 && jQuery(this).find("img").length > 5) {
                next.addClass('active');
            } else if (window.screen.width >= 992 && window.screen.width < 1200 && jQuery(this).find("img").length > 4) {
                next.addClass('active');
            } else if (window.screen.width < 992 && jQuery(this).find("img").length > 2) {
                next.addClass('active');
            }
        }
    });


/* -------------------------------------------------------
 * CAROUSEL PUSH MARKETING IMAGE
 * ------------------------------------------------------*/

    jQuery(".carousel-push-marketing-image").each(function () {
        var carousel = jQuery(this).owlCarousel({
            items : 4,
            itemsCustom : [
                [0, 1],
                [576, 2],
                [992, 3],
                [1200, 4],
            ],
            pagination: true,
            scrollPerPage : true,
            slideSpeed: 1500,
            autoPlay: false,
            stopOnHover: true,
            rewindNav: true,
            rewindSpeed: 1000,
            lazyLoad: true,
            addClassActive: true,
            afterMove: function(event) {
                displayNav(carousel);
            },
        });

        jQuery(this).closest('.carousel-wrapper').children(".carousel-prev").click(function(){
            carousel.trigger('owl.prev');
        });

        var next = jQuery(this).closest('.carousel-wrapper').children(".carousel-next");
		next.click(function(){
            carousel.trigger('owl.next');
        });
		if (window.screen.width >= 1200 && jQuery(this).find("img").length > 4) {
		    next.addClass('active');
		} else if (window.screen.width >= 992 && window.screen.width < 1200 && jQuery(this).find("img").length > 3) {
			next.addClass('active');
		} else if (window.screen.width >= 576 && window.screen.width < 992 && jQuery(this).find("img").length > 2) {
			next.addClass('active');
		} else if (window.screen.width < 576 && jQuery(this).find("img").length > 1) {
			next.addClass('active');
		}
    });


 /* -------------------------------------------------------
 * CAROUSEL CHANNEL
 * ------------------------------------------------------*/
    jQuery(".carousel-channel-mobile").each(function () {
        var carousel = jQuery(this).owlCarousel({
            items : 6,
            itemsCustom : [
                [0, 2],
                [480, 3],
                [576, 3],
                [768, 4],
                [992, 5],
                [1200, 6],
                [1600, 7],
            ],
            pagination: true,
            scrollPerPage : true,
            slideSpeed: 1500,
            autoPlay: false,
            dots: true,
            stopOnHover: true,
            rewindNav: true,
            rewindSpeed: 1000,
            addClassActive: true,
            afterMove: function(event) {
                displayNav(carousel);
            },
        });

        jQuery(this).closest('.carousel-wrapper').children(".carousel-prev").click(function(){
            carousel.trigger('owl.prev');
        });
        var next = jQuery(this).closest('.carousel-wrapper').children(".carousel-next");
        next.click(function(){
            carousel.trigger('owl.next');
        });
        if (window.screen.width >= 1600 && jQuery(this).find("img").length > 7) {
            next.addClass('active');
        } if (window.screen.width >= 1200 && window.screen.width < 1600 && jQuery(this).find("img").length > 6) {
            next.addClass('active');
        } else if (window.screen.width >= 992 && window.screen.width < 1200 && jQuery(this).find("img").length > 5) {
            next.addClass('active');
        } else if (window.screen.width >= 768 && window.screen.width < 992 && jQuery(this).find("img").length > 4) {
            next.addClass('active');
        } else if (window.screen.width >= 576 && window.screen.width < 768 && jQuery(this).find("img").length > 3) {
            next.addClass('active');
        } else if (window.screen.width >= 480 && window.screen.width < 576 && jQuery(this).find("img").length > 3) {
            next.addClass('active');
        } else if (window.screen.width < 480 && jQuery(this).find("img").length > 2) {
            next.addClass('active');
        }
    });

    jQuery(".carousel-channel-desktop").each(function () {
        var carousel = jQuery(this).owlCarousel({
            items : 6,
            itemsCustom : [
                [0, 2],
                [576, 3],
                [768, 4],
                [992, 5],
                [1200, 6],
                [1600, 7],
            ],
            pagination: true,
            scrollPerPage : true,
            slideSpeed: 1500,
            autoPlay: false,
            dots: true,
            stopOnHover: true,
            rewindNav: true,
            rewindSpeed: 1000,
            lazyLoad: true,
            addClassActive: true,
            afterMove: function(event) {
                displayNav(carousel);
            },
        });

        jQuery(this).closest('.carousel-wrapper').children(".carousel-prev").click(function(){
            carousel.trigger('owl.prev');
        });
        var next = jQuery(this).closest('.carousel-wrapper').children(".carousel-next");
        next.click(function(){
            carousel.trigger('owl.next');
        });
        if (window.screen.width >= 1600 && jQuery(this).find("img").length > 7) {
            next.addClass('active');
        } else if (window.screen.width >= 1200 && window.screen.width < 1600 && jQuery(this).find("img").length > 6) {
            next.addClass('active');
        } else if (window.screen.width >= 992 && window.screen.width < 1200 && jQuery(this).find("img").length > 5) {
            next.addClass('active');
        } else if (window.screen.width >= 768 && window.screen.width < 992 && jQuery(this).find("img").length > 4) {
            next.addClass('active');
        } else if (window.screen.width >= 576 && window.screen.width < 992 && jQuery(this).find("img").length > 3) {
            next.addClass('active');
        } else if (window.screen.width < 576 && jQuery(this).find("img").length > 2) {
            next.addClass('active');
        }
    });

    jQuery('.js-remove-from-playback-history').on('click', function(e) {
        e.preventDefault();
        var id = jQuery(this).attr('data-film-id');
        var url = jQuery(this).attr('data-href');
        var filmIcon = jQuery(this).parents('.owl-item');
        ajaxRemoveFromPlaybackHistory(url, id, filmIcon);
    });

    function ajaxRemoveFromPlaybackHistory(url, id, filmIcon) {
        jQuery.ajax({
            url: url,
            dataType: 'json',
            success : function(data) {
                filmIcon.parents('.slider').attr('id', 'playback');
                filmIcon.remove();
                if (jQuery('#playback .owl-item').length === 0) {
                    jQuery('#playback').hide();
                }
            }
        });
    };

});

document.addEventListener('DOMContentLoaded', function() {
    if (document.querySelector('.carousel-contributors')) {
        var mySwiper = new Swiper('.carousel-contributors', {
            direction: 'horizontal',
            loop: false,
            slidesPerView: 'auto',
            loopedSlides: null,
            keyboard: true,
            mousewheel: {
                releaseOnEdges: true,
            },
            slidesPerColumn: 1,
            spaceBetween: 10,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
                disabledClass: 'hidden',
                hiddenClass: 'hidden',
            },
        });
    }
});

document.addEventListener('DOMContentLoaded', function() {
    setTimeout(function(){
        if (document.querySelector('.carousel-testimonials')) {
            var mySwiper = new Swiper('.carousel-testimonials', {
                direction: 'horizontal',
                loop: false,
                loopedSlides: null,
                keyboard: true,
                mousewheel: {
                    releaseOnEdges: true,
                },
                slidesPerColumn: 1,
                spaceBetween: 10,
                slidesOffsetBefore: 0,
                slidesOffsetAfter: 0,
                slidesPerView: 1,
                breakpoints: {
                    // when window width is >= 468px
                    468: {
                        slidesPerView: 2,
                    },
                    // when window width is >= 992px
                    992: {
                        slidesPerView: 4,
                    }
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                    disabledClass: 'hidden',
                    hiddenClass: 'hidden',
                },
            });
        }
    }, 1000);
});

document.addEventListener('DOMContentLoaded', function() {
    if (document.querySelector('.carousel-seasons')) {
        var mySwiper = new Swiper('.carousel-seasons', {
            direction: 'horizontal',
            loop: false,
            slidesPerView: 'auto',
            loopedSlides: null,
            keyboard: true,
            mousewheel: {
                releaseOnEdges: true,
            },
            slidesPerColumn: 1,
            spaceBetween: 10,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
                disabledClass: 'hidden',
                hiddenClass: 'hidden',
            },
        });
    }
});
